import { render } from "./EditContactToClient.vue?vue&type=template&id=2c30d53f"
import script from "./EditContactToClient.vue?vue&type=script&lang=js"
export * from "./EditContactToClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__